export default "/images/images.svg?7a24158ebbb449a911e4f5a8efc0f7aa";